import {getAdjustment} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useAdjustment = () => {
  const results = useQueries({
    queries: [{queryKey: ['ORDER_ITEM_OVERVIEW_ADJUSTMENT'], queryFn: getAdjustment}],
  })

  const {adjustmentsJsonSchema, adjustmentsUISchema} = results?.[0]?.data || {}

  return {
    adjustmentsJsonSchema,
    adjustmentsUISchema,
  }
}
